import React from "react";
import Layout from "../../components/shared/Layout/Layout";
import CoachingPerformanceViewResults from "../../components/CoachingPerformanceViewResults/CoachingPerformanceViewResults";

const ViewCoachingPerformancePage = () => {
  return (
    <div
      className="bg_dark"
      style={{ minHeight: "100vh", position: "relative" }}
    >
      <Layout title={`View Coaching Performance`}>
        <CoachingPerformanceViewResults />
      </Layout>
    </div>
  );
};

export default ViewCoachingPerformancePage;
